import * as angular from "angular";
import {IController} from "angular";

export class tasksAdditionsCtrl implements IController {

  additions: any;

  constructor() {
  }

  $onInit() {

  }

}
angular
  .module('bringoz.admin.pricePlan')
  .component('additionsDisplayList', {
    bindings: {
      additions: '<',
    },
    template: require('./additions-display-list.html').default,
    controller: tasksAdditionsCtrl
  });
